<div class="container-fluid">

  <div class="d-flex justify-content-between align-items-center flex-wrap">

    <!-- Titre à gauche -->
    <h4 id="upper" class="mb-0">Activité hors Pta</h4>

    <!-- Filtres à droite -->
    <div class="d-flex align-items-center gap-3 flex-wrap">

      <label class="d-flex align-items-center">
        Début:
        <input type="date" class="form-control ms-2" [(ngModel)]="dateDebut" (change)="getActiviteHorsPta()"
          name="dateDebut">
      </label>

      <label class="d-flex align-items-center">
        Fin:
        <input type="date" class="form-control ms-2" [(ngModel)]="dateFin" (change)="getActiviteHorsPta()"
          name="dateFin">
      </label>

      <label class="d-flex align-items-center">
        Service:
        <select style="width: 200px;" name="directionFilter" [(ngModel)]="selectedService"
          (change)="getActiviteHorsPta()" class="form-select ms-2">
          <option value="">Sélectionner un service</option>
          <option *ngFor="let item of serviceItems" [value]="item.id">{{item.libelle}}</option>
        </select>
      </label>

      <div class="dropdown d-inline-block" ngbDropdown>
        <button type="button" ngbDropdownToggle class="btn btn-secondary dropdown-toggle" id="dropdownMenuButton"
          aria-haspopup="true" aria-expanded="false">
          Exporter <i class="pi pi-upload" style="font-size: 0.8rem"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item" href="javascript:void(0);" (click)="exportToDocumentHorsPta('pdf')"> Activités</a>
          <a class="dropdown-item" href="javascript:void(0);" (click)="exportToDocument('pdf')">Etat système</a>
        </div>
      </div>

    </div>

  </div>

  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div>
            <!--  -->
            <a href="javascript:void(0);" (click)="openModal()" class="btn btn-success mb-2" id="gras">
              <i class="mdi mdi-plus me-2"></i> Ajouter une activité hors-PTA
            </a>
          </div>

          <div class="table-responsive mt-3">
            <table class="table table-centered datatable dt-responsive nowrap"
              style="border-collapse: collapse; border-spacing: 0; width: 100%;">
              <thead class="thead-light  rwd-table">
                <tr>
                  <th style="width: 20px; ">
                  </th>
                  <th style="white-space: nowrap;">Activité non prévues</th>

                  <th style="white-space: nowrap;">Réalisée le </th>
                  <th style="white-space: nowrap;">Montant</th>
                  <th>Services</th>
                  <th>Observations</th>
                  <th style="width: 120px;"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of paginatedProjets; let index = index">
                  <td>
                  </td>
                  <td>{{item?.libelle}}</td>
                  <td>{{item?.date_realisation | dateFormat}}</td>
                  <td>{{item?.montant | formatMoney:null}}</td>
                  <td>{{item?.service?.libelle || '-'}}</td>
                  <td>{{item?.observations}}</td>
                  <td>
                    <a style="cursor: pointer;" (click)="editModal(item)" class="me-3 text-primary" v-b-tooltip.hover
                      title="Modifier">
                      <i class="mdi mdi-pencil font-size-18"></i>
                    </a>
                    <a href="javascript:void(0);" (click)="confirmSuppression(item)" class="text-danger"
                      v-b-tooltip.hover title="Retirer">
                      <i class="mdi mdi-trash-can font-size-18"></i>
                    </a> &nbsp;&nbsp;

                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="d-flex justify-content-center" *ngIf="isLoading === true">
            <div class="container">
              <div class="row">
                <div class="text-center">
                  <h5 id="graycolor">Chargement en cours...</h5>
                  <div class="loader4"></div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="paginatedProjets.length === 0 && isLoading === false" class="d-flex justify-content-center">
            <div class="container">
              <div class="row">
                <div class="text-center">
                  <h5 id="graycolor">Aucune donnée trouvée</h5>
                </div>
              </div>
            </div>

          </div>
          <p-paginator (onPageChange)="onPageChangeProjets($event)" [first]="firstProjets" [rows]="rowsProjets"
            [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 30]">
          </p-paginator>
        </div>
      </div>
    </div>


  </div>
</div>


<ng-template #addmodalContent let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Ajouter une activité hors pta</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="container-fluid">
      <form>
        <div class="row">

          <!-- Service -->
          <div class="col-md-6 mb-3">
            <label>Service</label>
            <select name="service" [(ngModel)]="item.service_id" class="form-select ms-2">
              <option value="">Sélectionner un service</option>
              <option *ngFor="let item of serviceItems" [value]="item.id">{{item.libelle}}</option>
            </select>
          </div>

          <!-- Date de réalisation -->
          <div class="col-md-6 mb-3">
            <label>Date de réalisation</label>
            <input type="date" class="form-control" [(ngModel)]="item.date_realisation" name="dateRealisation">
          </div>

          <!-- Activité -->
          <div class="col-md-12 mb-3">
            <label>Activité</label>
            <input type="text" class="form-control" [(ngModel)]="item.libelle" name="activite">
          </div>

          <!-- Observation -->
          <div class="col-md-6 mb-3">
            <label>Observation</label>
            <textarea class="form-control" rows="3" [(ngModel)]="item.observations" name="observation"></textarea>
          </div>

          <!-- Montant -->
          <div class="col-md-6 mb-3">
            <label>Montant</label>
            <input type="number" class="form-control" [(ngModel)]="item.montant" name="montant">
          </div>

        </div>
      </form>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Close click')">Fermer</button>
    <button type="button" class="btn btn-primary" (click)="addHorsActivitePta()">Enregistrer</button>
  </div>
</ng-template>


<ng-template #editmodalContent let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Modifier une activité hors pta</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="container-fluid">
      <form>
        <div class="row">

          <!-- Service -->
          <div class="col-md-6 mb-3">
            <label>Service</label>
            <select name="service" [(ngModel)]="editItem.service_id" class="form-select ms-2">
              <option value="">Sélectionner un service</option>
              <option *ngFor="let item of serviceItems" [value]="item.id">{{item.libelle}}</option>
            </select>
          </div>

          <!-- Date de réalisation -->
          <div class="col-md-6 mb-3">
            <label>Date de réalisation</label>
            <input type="date" class="form-control" [(ngModel)]="editItem.date_realisation" name="date_realisation">
          </div>

          <!-- Activité -->
          <div class="col-md-12 mb-3">
            <label>Activité</label>
            <input type="text" class="form-control" [(ngModel)]="editItem.libelle" name="activite">
          </div>

          <!-- Observation -->
          <div class="col-md-6 mb-3">
            <label>Observation</label>
            <textarea class="form-control" rows="3" [(ngModel)]="editItem.observations" name="observation"></textarea>
          </div>

          <!-- Montant -->
          <div class="col-md-6 mb-3">
            <label>Montant</label>
            <input type="number" class="form-control" [(ngModel)]="editItem.montant" name="montant">
          </div>

        </div>
      </form>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Close click')">Fermer</button>
    <button type="button" class="btn btn-primary" (click)="updateHorsActivitePta()">Modifier</button>
  </div>
</ng-template>




<p-confirmDialog />
<p-toast />
<ngx-ui-loader></ngx-ui-loader>